module.exports = __webpack_public_path__ + "static/media/welcome-yoga.55354d97.svg";